export const {REACT_APP_FITVIEW_CLIENT_URL,REACT_APP_SWAN_API_SERVER_URL,REACT_APP_CHILD_URL,REACT_APP_ACCESS_KEY}  = process.env;
export const PARAMS_NAME={
    SCAN_ID:"scan_id",
    EMAIL:"email",
    TOKEN:"token",
    FIT:"fit",
    CART:"cart"
    
}
export const STORAGE_KEY={
    SCAN_ID:"scanID",
    EMAIL:"email",
    JWTToken:"JWTToken"
}

export const MESSAGE_KEY={
    REDIRECT:"REDIRECT",
    REQUEST:"REQUEST",
    DETAILS:"DETAILS",
    CLOSE:"CLOSE",
    INFO:"INFO"
}
export const CUSTOM_STORE={
    HOUSE_OF_ALDENO:'aldeno-laguna-clothing.myshopify.com',
    SWAN_CUSTOM_STORE_STAGING:'swan-custom-staging.myshopify.com'
}